import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getActiveXList = ( accessToken, CodTpActiveX ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/spGetActiveX?CodTpActiveX=${CodTpActiveX}`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

export {getActiveXList}